import {route} from "ziggy-js";
import {removeAuthToken} from "./AuthTokenHelper";

/**
 * AuthHelper::logout();
 */
export const logout = () => {
    axios.get(route('api.admin.logout'))
        .finally((response) => {
            removeAuthToken();

            window.location.href = route('admin.login', {
                status: 'logged_out'
            });
        });
}

/**
 * AuthHelper::redirectToLogin()
 */
export const redirectToLogin = () => {
    window.location.href = route('admin.login', {
        status: 'unauthenticated'
    });
}
